export abstract class TrackingLabel<ValueType = unknown> {
  abstract readonly name: string;
  abstract readonly value: ValueType;

  abstract isTrackable(): boolean;

  get data(): { [key: string]: ValueType } {
    if (!this.isTrackable()) {
      return {};
    }
    return {
      [this.name]: this.value
    };
  }
}
